export const setKameleoonCustomData = (key: string, value: string) => {
  window?.kameleoonQueue?.push(['Data.setCustomData', key, value]);
  window?.kameleoonQueue?.push(['Data.writeLocalData', key, value]);
};
